import { useEffect } from "react";

import { type PageMetadata, useMetadata } from "../hooks";

export const SetMetadata = (metadata: PageMetadata) => {
  const { handleMetadata } = useMetadata();

  useEffect(() => handleMetadata(metadata), []);

  return null;
};
